import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import _ from "lodash";
import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import CloudFlareForm from "./cloudFlareForm";
import { clouds } from "../../../utils/icons";
import { createCloudFlareIntegration } from "../../../redux/actions/cloudFlareIntegrationActions";

import "./cloudFlareIntegration.scss";

const CloudFlareIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "Cloudflare Integration setup",
      content_title: "Cloudflare Integration",
      content: (
        <CloudFlareForm
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);
        const req = await dispatch(
          createCloudFlareIntegration(
            wizardState?.name,
            wizardState?.token,
          )
        );
        setLoadingSubmit(false);
        if (!req?.ok) {
          throw new Error(
            `Failed to create Cloudflare integration.`
          );
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled} 
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="CloudFlareIntegration">
      <AppWizard
        iconSrc={clouds("cloudflare")}
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
      />
    </div>
  );
};

export default CloudFlareIntegration;
